import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.canvas = document.createElement('canvas')
    this.ctx = this.canvas.getContext('2d')

    this.element.style.position = 'relative'
    this.canvas.style.position = 'absolute'
    this.canvas.style.top = '0'
    this.canvas.style.left = '0'
    this.canvas.style.width = '100%'
    this.canvas.style.height = '100%'
    this.canvas.style.zIndex = '-1'
    this.element.prepend(this.canvas)

    this.colors = [
      { r: 220, g: 242, b: 255, a: 0.5 },  // 清新天蓝
      { r: 190, g: 248, b: 255, a: 0.48 }, // 明亮青蓝
      { r: 210, g: 235, b: 252, a: 0.48 }, // 清透天蓝
      { r: 240, g: 220, b: 255, a: 0.45 }, // 柔和淡紫
      { r: 248, g: 230, b: 255, a: 0.48 }, // 明亮粉紫
      { r: 255, g: 225, b: 195, a: 0.45 }, // 柔和桃橙
      { r: 255, g: 210, b: 165, a: 0.48 }, // 明亮橙
    ]

    this.blobs = []
    this.createBlobs()

    this.resize()
    this.resizeHandler = () => this.resize()
    window.addEventListener('resize', this.resizeHandler)

    this.animate()
  }

  disconnect() {
    window.removeEventListener('resize', this.resizeHandler)
    if (this.animationFrame) cancelAnimationFrame(this.animationFrame)
  }

  resize() {
    const rect = this.element.getBoundingClientRect()
    this.canvas.width = rect.width
    this.canvas.height = rect.height
  }

  createBlobs() {
    this.blobs = []

    const blobCount = 8 + Math.floor(Math.random() * 5)
    for (let i = 0; i < blobCount; i++) {
      this.blobs.push({
        x: Math.random(),
        y: Math.random(),
        radius: 0.15 + Math.random() * 0.25,
        speedX: (Math.random() - 0.5) * 0.0003,
        speedY: (Math.random() - 0.5) * 0.0003,
        color: this.colors[Math.floor(Math.random() * this.colors.length)],
        phase: Math.random() * Math.PI * 2,
        breathSpeed: 0.001 + Math.random() * 0.002
      })
    }
  }

  animate() {
    const width = this.canvas.width
    const height = this.canvas.height

    this.ctx.filter = 'none'
    this.ctx.fillStyle = 'rgb(255, 255, 255)'
    this.ctx.fillRect(0, 0, width, height)

    this.blobs.forEach(blob => {
      blob.x += blob.speedX
      blob.y += blob.speedY

      if (blob.x < -0.2 || blob.x > 1.2) blob.speedX *= -1
      if (blob.y < -0.2 || blob.y > 1.2) blob.speedY *= -1

      blob.phase += blob.breathSpeed
      const breathScale = 1 + Math.sin(blob.phase) * 0.1

      const x = blob.x * width
      const y = blob.y * height
      const maxDim = Math.max(width, height)
      const radius = blob.radius * maxDim * breathScale

      const gradient = this.ctx.createRadialGradient(x, y, 0, x, y, radius)
      const { r, g, b, a } = blob.color

      gradient.addColorStop(0, `rgba(${r}, ${g}, ${b}, ${a * 0.85})`)
      gradient.addColorStop(0.35, `rgba(${r}, ${g}, ${b}, ${a * 0.55})`)
      gradient.addColorStop(0.65, `rgba(${r}, ${g}, ${b}, ${a * 0.25})`)
      gradient.addColorStop(1, `rgba(${r}, ${g}, ${b}, 0)`)

      this.ctx.fillStyle = gradient
      this.ctx.fillRect(x - radius, y - radius, radius * 2, radius * 2)
    })

    this.ctx.filter = 'blur(1px)'

    this.animationFrame = requestAnimationFrame(() => this.animate())
  }
}